module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "padded"
  }, [_c('v-btn', {
    attrs: {
      "fab": "",
      "small": "",
      "color": "yellow",
      "top": "",
      "right": "",
      "absolute": ""
    },
    on: {
      "click": _vm.newMessage
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _vm._l((_vm.messages), function(message, index) {
    return _c('div', [_c('div', {
      class: {
        'message-from-me': _vm.user.id === message.author, 'message-from-them': _vm.user.id !== message.author
      }
    }, [_c('div', {
      staticClass: "message-author"
    }, [_vm._v(_vm._s(message.author_fullname))]), _vm._v(" "), _c('div', {
      staticClass: "message-date"
    }, [_vm._v(_vm._s(_vm.formatDate(message.date)))]), _vm._v(" "), _c('div', {
      staticClass: "message-text"
    }, [_vm._v(" " + _vm._s(message.text))])]), _vm._v(" "), _c('div', {
      staticClass: "clear"
    })])
  })], 2), _vm._v(" "), (_vm.messages.length === 0) ? _c('v-card-text', {
    staticClass: "Aligner",
    staticStyle: {
      "height": "100px"
    }
  }, [_c('v-icon', [_vm._v("not_interested")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "800"
    },
    model: {
      value: (_vm.newMessageDialog),
      callback: function($$v) {
        _vm.newMessageDialog = $$v
      },
      expression: "newMessageDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2"
  }, [_vm._v("Nouveau message")]), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Destinataires",
      "multiple": "",
      "chips": "",
      "cache-items": "",
      "items": _vm.possible_targets,
      "item-text": "fullname",
      "item-value": "id",
      "blur": "$v.messageToSend.$touch(); $v.messageToSend.$touch()",
      "error-messages": _vm.targetsErrors
    },
    on: {
      "input": function($event) {
        _vm.$v.messageToSend.$touch();
        _vm.$v.messageToSend.$touch()
      }
    },
    model: {
      value: (_vm.messageToSend.visible_by),
      callback: function($$v) {
        _vm.$set(_vm.messageToSend, "visible_by", $$v)
      },
      expression: "messageToSend.visible_by"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Texte",
      "required": "",
      "error-messages": _vm.textErrors
    },
    on: {
      "input": function($event) {
        _vm.$v.messageToSend.$touch();
        _vm.$v.messageToSend.$touch();
        _vm.onChanged()
      }
    },
    model: {
      value: (_vm.messageToSend.text),
      callback: function($$v) {
        _vm.$set(_vm.messageToSend, "text", $$v)
      },
      expression: "messageToSend.text"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.formValidAndDirty,
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.newMessageDialog = false;
        _vm.sendMessage(_vm.messageToSend)
      }
    }
  }, [_vm._v("Envoyer")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.newMessageDialog = false
      }
    }
  }, [_vm._v("Annuler")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2701bc87","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/messages/Messages.vue
// module id = 1177
// module chunks = 1